module.exports = ".close {\r\n  float: right !important;\r\n  font-size: 21px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  color: #000;\r\n  text-shadow: 0 1px 0 #fff;\r\n  filter: alpha(opacity=20);\r\n  opacity: .2;\r\n  cursor: pointer;\r\n}\r\n\r\nbutton, button:hover {\r\n  float: unset;\r\n}\r\n\r\nbutton:focus {\r\n  -webkit-box-shadow: unset;\r\n          box-shadow: unset;\r\n}\r\n\r\n.message-bar {\r\n  padding: 5px 5px 0 5px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-iata/manage-dialog/manage-dialog.component.css
// module id = ./src/app/manage-iata/manage-dialog/manage-dialog.component.css
// module chunks = main